import React, { useEffect, useState } from "react";
import {
  Button,
  FormFieldSet,
  Modal,
  showToast,
  TableAdv,
  useFormHandler,
  LogoLoader,
  Backdrop,
} from "../../../../../components";
import { useDispatch, useSelector } from "react-redux";
import {
  addUsersIntegrationAccess,
  getAllIntegrationAccess,
  updateIntegrationAccessStatus,
} from "../../../../../redux/slices/setting/settingApi";
import { mapTableRows } from "../../../../../utils";
import { usePagination } from "../../../../../hooks";
import { totalCountStart } from "../../../../../redux/slices/totalCount/totalCountSlice";
import { formatWords2 } from "../../../../../utils/stringUtils";
import {
  addUsersIntegrationAccessBs,
  assignAccessToEmailAccountBS,
  getAllIntegrationAccessBs,
  getemailAccessBs,
  updateIntegrationAccessStatusBs,
  updateIntegrationAccessStatusBsMail,
} from "../../../../../redux/slices/ats/benchSales/benchSalesApi";
import {
  addUsersIntegrationAccessNm,
  getAllIntegrationAccessNm,
  updateIntegrationAccessStatusNm,
} from "../../../../../redux/slices/nonitMarketing/nonitMarketingApi";

const AddBulkList = ({
  isOpen,
  onClose,
  onValueChange,
  category,
  existingData,
  type,
  showConnectModal,
  selectedModule,
}) => {
  // const [emails, setEmails] = useState([]);
  const { user } = useSelector((state) => state?.auth);
  const [integrationData, setIntegrationData] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const intitialformData = {
    emailsList: [],
    limit: "",
    emails: [],
    email: "",
    extension: "",
  };
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => { },
  );

  const { value } = useSelector((state) => state?.totalCount);
  const totalCount =
    selectedModule === "bs"
      ? value?.addBulkListTableCountBs?.data?.total
      : value?.addBulkListTableCount?.data || 0;
  const [editedRows, setEditedRows] = useState({});
  // console.log(editedRows)

  useEffect(() => {
    if (!isOpen) return; // run only when modal is open
    if (!existingData) return;

    console.log({ existingData });
    const fetchAccessData = async () => {
      setLoading(true);

      try {
        const params = {
          // coll:selectedModule === "bs" ? "Integrationaccess" : "IntegrationAccess",
          lim: 1000,
          pg: 1,
          //useAggregate: false,
          fil: {
            integrationId: {
              type: "NONE",
              value: existingData,
            },
          },
          ref: "UserId",
          incl: "firstName lastName ",
          // sort: { addedOn: -1 },

        };

        // const response = selectedModule === "bs" ? await getAllIntegrationAccessBs(params)
        //         : await getAllIntegrationAccess(params);
        let response;
        if (selectedModule === "bs") {
          response = await getAllIntegrationAccessBs({
            ...params,
            coll: "Integrationaccess",
            skipException: true,
          });
        } else if (selectedModule === "nm") {
          response = await getAllIntegrationAccessNm({
            ...params,
            coll: "Integrationaccess",
          });


        } else {
          //  ats flow
          response = await getAllIntegrationAccess({
            ...params,
            coll: "IntegrationAccess",
          });
        }

        //  SUCCESS CONDITION
        if (response?.data?.data) {
          setIntegrationData(response?.data?.data); // store data
          // console.log("Integration Access Data:", response?.data?.data);
        } else {
          setIntegrationData([]);
          console.warn("No data found");
        }
      } catch (error) {
        console.error("Error fetching integration access:", error);
      } finally {
        setLoading(false);
      }
    };

    if (selectedModule === "ats") {
      dispatch(
        totalCountStart({
          collection: "integrationaccesss",
          coll: "IntegrationAccess",
          tname: "addBulkListTableCount",
          filters: {
            integrationId: {
              type: "NONE",
              value: existingData,
            },
          },
          app: "ats",
        }),
      );
    } else if (selectedModule === "bs") {
      dispatch(
        totalCountStart({
          //  ...params,
          collection: "integrationaccesss",
          coll: "Integrationaccess",
          tname: "addBulkListTableCountBs",
          filters: {
            integrationId: {
              type: "NONE",
              value: existingData,
            },
          },
          app: "bs",
        }),
      );
    }

    fetchAccessData();
  }, [isOpen, existingData, limit, page, selectedModule]);

  const { formData, errors, handleChange } = useFormHandler(
    intitialformData,
    {},
  );

  // const options = names.map((name, in
  // x) => ({
  //   label: name,
  //   value: index + 1,
  // }));

  const tableColumn = [
    {
      key: "whoCanUse",
      label: "Who Can Use",
      columnMenu: false,
    },

    {
      key: "emailsList",
      label: "Emails List",
      columnMenu: false,
      render: (row) => (
        <FormFieldSet
          noTitle
          multiple
          type="email"
          placeholder="Enter Emails"
          value={row.emailsList}
          onChange={(value) => handleRowChange(row, "emailsList", value)}
        />
      ),
    },
    {
      key: "replyTo",
      label: "Reply To",
      columnMenu: false,
      render: (row) => (
        <FormFieldSet
          noTitle
          size="sm"
          placeholder="Reply To"
          value={row.replyTo}
          onChange={(value) => handleRowChange(row, "replyTo", value)}
        />
      ),
    },
    {
      key: "dailyUserLimit",
      label: "Daily User Limit",
      columnMenu: false,
      render: (row) => (
        <FormFieldSet
          noTitle
          size="sm"
          placeholder="Daily Limit"
          value={row.dailyUserLimit}
          onChange={(value) => handleRowChange(row, "dailyUserLimit", value)}
        />
      ),
    },

    {
      key: "access",
      label: "Access",
      columnMenu: false,
      render: (row) => (
        <Button
          type="icon"
          variant="text"
          // icon={"toggle_on"}
          icon={row.access === 1 ? "toggle_on" : "toggle_off"}
          color={row.access === 1 ? "success" : "black"}
          // color={toggleOn.includes(row.id) ? "success" : "color"}
          // color="black"
          size="sm"
          onClick={() =>
            toggleUsersIntegrationAccess(row.uiid, row.access === 1 ? 2 : 1)
          }
        // onClick={() => handleStatusToggle(row)}
        />
      ),
    },
    // {
    //   key: "status",
    //   label: "Status",
    //   columnMenu: false,
    //   render: (row) => <div className="text-info-500">1 downloaded</div>,
    // },
  ];

  const benchSalesColumns = [
    {
      key: "whoCanUse",
      label: "Who Can Use",
      columnMenu: false,
    },
    {
      key: "extension",
      label: "Extension",
      columnMenu: false,
      render: (row) => <span>{row.extension || "-"}</span>,
    },

    {
      key: "access",
      label: "Access",
      columnMenu: false,
      render: (row) => (
        <Button
          type="icon"
          variant="text"
          // icon={"toggle_on"}
          icon={row.access === 1 ? "toggle_on" : "toggle_off"}
          color={row.access === 1 ? "success" : "black"}
          // color={toggleOn.includes(row.id) ? "success" : "color"}
          // color="black"
          size="sm"
          onClick={() =>
            toggleUsersIntegrationAccess(row.uiid, row.access === 1 ? 2 : 1)
          }
        // onClick={() => handleStatusToggle(row)}
        />
      ),
    },
  ];

  const voipColumns = [
    {
      key: "whoCanUse",
      label: "Who Can Use",
      columnMenu: false,
    },

    {
      key: "extension",
      label: "Extension",
      columnMenu: false,
      render: (row) => <span>{row.extension || "-"}</span>,
    },

    {
      key: "access",
      label: "Access",
      columnMenu: false,
      render: (row) => (
        <Button
          type="icon"
          variant="text"
          // icon={"toggle_on"}
          icon={row.access === 1 ? "toggle_on" : "toggle_off"}
          color={row.access === 1 ? "success" : "black"}
          // color={toggleOn.includes(row.id) ? "success" : "color"}
          // color="black"
          size="sm"
          onClick={() =>
            toggleUsersIntegrationAccess(row.uiid, row.access === 1 ? 2 : 1)
          }
        // onClick={() => handleStatusToggle(row)}
        />
      ),
    },
  ];


  const toggleUsersIntegrationAccess = async (uiid, status) => {
    try {
      const payload = [
        {
          type: "SET",
          value: { status },
        },
      ];
      setLoading(true);
      const updateStatus =
        selectedModule === "bs"
          ? await updateIntegrationAccessStatusBs({
            uiid,
            payload,
            email: existingData?.email,
          })
          : selectedModule === "nm"
            ? await updateIntegrationAccessStatusNm({
              uiid,
              payload,
              email: existingData?.email,
            }) : await updateIntegrationAccessStatus({ uiid, payload });

      if (updateStatus?.data?.data) {
        // console.log("update api",updateStatus?.data?.data?.doc)

        const doc = updateStatus?.data?.data?.doc;

        setIntegrationData((prev) =>
          prev.map((item) =>
            item.uiid === doc.uiid ? { ...item, status: doc.status } : item,
          ),
        );
        showToast("Integration Access status updated successfully", "success");
        setLoading(false);
      } else {
        showToast("Failed to update Integration Access status", "error");
        setLoading(false);
      }
    } catch (err) {
      console.error("Error updating integration Access status:", err);
      showToast("Failed to update Integration Access status", "error");
      setLoading(false);
    }
  };

  const handleRowChange = (row, field, value) => {
    console.log("Row Change:", row);
    console.log("field Change:", field);
    console.log("value Change:", value);
    setEditedRows((prev) => ({
      ...prev,
      [row.uiid]: {
        ...prev[row.uiid],
        [field]: value,
      },
    }));

    setIntegrationData((prev) =>
      prev.map((item) =>
        item.uiid === row.uiid
          ? {
            ...item,
            accessConfig: {
              ...item.accessConfig,
              ...(field === "emailsList" && { emails: value }),
              ...(field === "replyTo" && { replyTo: value }),
              ...(field === "dailyUserLimit" && { limit: value }),
              ...(field === "email" && { email: value }),
              ...(field === "password" && { password: value }),
              ...(field === "extension" && { extension: value }),
            },
          }
          : item,
      ),
    );
  };

  // console.log("integrationData",integrationData);

  const rows = integrationData.map((item) => ({
    uiid: item.uiid,

    whoCanUse:
      `${formatWords2(item?.userId?.firstName ?? "")} ${formatWords2(item?.userId?.lastName ?? "")}`.trim(),

    emailsList: item.accessConfig?.emails || [],

    replyTo: item.accessConfig?.replyTo || "",

    dailyUserLimit: item.accessConfig?.limit || "-",

    access: item.status === 1 ? 1 : 2,

    password: item.accessConfig?.password || "",
    extension: item.accessConfig?.extension || "",
    email:
      category === 11 && (type === 7 || type === 8)
        ? item?.email || ""
        : item.accessConfig?.email || "",
  }));

  // function extractEmails(str) {
  //   if (!str || typeof str !== "string") return [];

  //   return str
  //     .split(/[\s,;\n]+/)     // split by comma, space, semicolon, newline
  //     .map((e) => e.trim())   // remove extra spaces
  //     .filter(
  //       (e) => e.length > 0 &&
  //         /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)  // valid email format
  //     );
  // }
  console.log("editedRows", editedRows);
  const handleUpdate = async () => {
    try {
      setLoading(true);

      // map all edited rows to API payloads
      const requests = Object.entries(editedRows).map(([uiid, fields]) => ({
        uiid, // row uiid
        payload: [
          {
            type: "SET",
            value: {
              // status: 1,
              accessConfig: {
                ...(fields.emailsList && { emails: fields.emailsList }),
                ...(fields.replyTo && { replyTo: fields.replyTo }),
                ...(fields.dailyUserLimit && { limit: fields.dailyUserLimit }),
                ...(fields.email && { email: fields.email }),
                ...(fields.password && { password: fields.password }),
                ...(fields.extension && { extension: fields.extension }),
              },
            },
          },
        ],
      }));

      // call API for all edited rows
      selectedModule === "bs"
        ? await Promise.all(
          requests.map((req) => updateIntegrationAccessStatusBs(req)),
        )
        : await Promise.all(
          requests.map((req) => updateIntegrationAccessStatus(req)),
        );

      showToast("Integration Access updated successfully", "success");

      // clear edited rows after update
      setEditedRows({});
    } catch (error) {
      console.error("Error updating integration access:", error);
      showToast("Failed to update Integration Access", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    // Required field validation
    if (!selectedUsers || !selectedUsers.value) {
      showToast("Please select a user!", "error", 2000);
      return;
    }

    const emailData = formData.emails;
    console.log({ emailData });

    if (selectedModule === "ats" && (!emailData || emailData.length === 0)) {
      showToast("Please enter at least one email!", "error", 2000);
      return;
    }

    // if(selectedModule === "bs" && !formData?.email&&(category === 11 && type === 7)){
    //   showToast("Please enter email!", "error", 2000);
    //   return;
    // }
    if (
      selectedModule === "bs" &&
      !formData?.emails?.length > 0 &&
      !(category === 11 && (type === 7 || type === 8)) &&
      category !== 1
    ) {
      showToast("Please enter emails!", "error", 2000);
      return;
    }

    if (category === 1 && !formData?.extension) {
      showToast("Please enter extension!", "error", 2000);
      return;
    }

    if (category === 1 && formData?.extension) {
      setLoading(true);
      try {
        const checkParams = {
          lim: 1000,
          pg: 1,
          fil: {
            integrationId: { type: "NONE", value: existingData }
          }
        };

        let checkResponse;
        if (selectedModule === "bs") {
          checkResponse = await getAllIntegrationAccessBs({
            ...checkParams,
            coll: "Integrationaccess",
            skipException: true,
          });
        } else if (selectedModule === "nm") {
          checkResponse = await getAllIntegrationAccessNm({
            ...checkParams,
            coll: "Integrationaccess",
          });
        } else {
          checkResponse = await getAllIntegrationAccess({
            ...checkParams,
            coll: "IntegrationAccess",
          });
        }

        const existingUsers = checkResponse?.data?.data || [];
        const isExtensionInUse = existingUsers.some(
          (userAcc) => String(userAcc?.accessConfig?.extension) === String(formData.extension)
        );

        if (isExtensionInUse) {
          showToast("This extension is already assigned to another user!", "error", 3000);
          setLoading(false);
          return;
        }
      } catch (err) {
        console.error("Error checking extension uniqueness:", err);
      }
    }

    setLoading(true);

    const replyTo = emailData?.length
      ? emailData[emailData.length - 1]?.replace("mg.", "").trim()
      : "";
    const normalizedUserId =
      typeof selectedUsers === "object" && selectedUsers !== null
        ? selectedUsers.value
        : selectedUsers;
    try {
      const payload = {
        coll: "IntegrationAccess",
        payload: {
          userId: normalizedUserId,
          integrationId: existingData || null,
          accessConfig: {
            ...(selectedModule === "ats" && {
              replyTo: replyTo,
              emails: emailData,
              limit: "1000",
            }),
            ...((selectedModule === "bs" || selectedModule === "nm") && {
              password: formData.password,
              email: formData.email,
              emails: emailData,
              replyTo: replyTo,
              limit: "1000",
              extension: formData.extension,
            }),
          },
          addedBy: user?.data?.uiid,
        },
      };

      console.log({ payload });
      let finalPayload = payload; // default (existing logic)

      //  ONLY for Gmail Account Assign Access
      if (
        selectedModule === "bs" &&
        category === 11 &&
        (type === 7 || type === 8)
      ) {
        finalPayload = {
          authTokenId: existingData?._id, //  THIS is your saved authTokenId
          recruiterId:
            typeof selectedUsers === "object"
              ? selectedUsers.value
              : selectedUsers,
        };
      }

      let response;

      if (selectedModule === "bs") {
        {
          response = await addUsersIntegrationAccessBs(payload);
        }
      } else if (selectedModule === "nm") {
        response = await addUsersIntegrationAccessNm(payload);

      } else {
        response = await addUsersIntegrationAccess(payload);
      }

      if (response?.data) {
        onValueChange(true);
        onClose();
        showToast("Added Users successfully!", "success", 2000);
        setSelectedUsers("");
        handleChange("emails", "");
      }
      // else {
      //   showToast("Failed to Add Users!", "error", 2000);
      // }
    } catch (error) {
      console.error(" API error:", error);
      showToast("Something went wrong!", "error", 2000);
    } finally {
      setLoading(false);
    }
  };

  const mappedRows = mapTableRows(
    rows,
    category === 11 && (type === 7 || type === 8)
      ? benchSalesColumns
      : category === 1
        ? voipColumns
        : tableColumn,
  );

  return (
    <div>
      <Modal
        isOpen={isOpen}
        title="Add List"
        width="max-w-5xl"
        onClose={onClose}
      >
        <div className="grid grid-cols-3 mb-3 items-center gap-2">
          {/* <FormFieldSet
            type="allUsers"
            placeholder="Select"
            title="Users List"
            // options={options}
            value={selectedUsers}
            onChange={(v) => setSelectedUsers(v.value)}
          /> */}
          <FormFieldSet
            //             type={
            //               selectedModule === "bs" || selectedModule === "nm"
            // ? category === 11 && type === 7
            //                   ? "getJobBoardUsersBs"
            //                   : "getJobBoardUsersBs"
            //                 : "getJobBoardUsers"
            //             }
            type={
              selectedModule === "bs" &&
              category === 11 &&
              (type === 7 || type === 8)
                ? "getJobBoardUsersBs"
                : selectedModule === "nm" &&
                    category === 11 &&
                    (type === 7 || type === 8)
                  ? "getJobBoardUsersNm"
                  : "getJobBoardUsers"
            }
            // type={selectedModule === "bs" ? "getCandidateAuthEmailsBs" : "getJobBoardUsers"}
            showSearch
            placeholder="Select"
            title="Users List"
            // options={options}
            value={selectedUsers}
            // onChange={(v) => setSelectedUsers(v.value)}
            onChange={(value) => {
              setSelectedUsers(value);
              if (category === 11 && type === 7 && value?.email) {
                handleChange("email", value.email);
              }
            }}
          />
          {category === 1 || selectedModule === "bs" ? (
            <FormFieldSet
              value={formData.extension}
              type="text"
              title="Extension"
              placeholder="Enter Extension"
              onChange={(value) => handleChange("extension", value)}
            />
          ) : null}
          {category === 11 && type !== 7 && type !== 8 ? (
            <FormFieldSet
              value={formData.emails}
              type="email"
              title="Emails (Type Emails and Press Enter)"
              placeholder="Type Emails and Press Enter"
              onChange={(value) => handleChange("emails", value)}
              multiple
            // disabled={}
            />
          ) : null}

          <div className="flex items-end justify-start">
            {category === 11 && (type === 7 || type === 8) ? (
              <Button
                title={"Add Account"}
                onClick={handleSubmit}
                size="sm"
                className="w-fit mt-5"
              />
            ) : (
              <Button
                title={"Submit"}
                onClick={handleSubmit}
                size="sm"
                className="w-fit mt-5"
              />
            )}
          </div>
        </div>

        <TableAdv
          tableId={`ats_marketplace_bulkemailsmodal_addbulklist_${type}_table`}
          columns={
            category === 11 && (type === 7 || type === 8)
              ? benchSalesColumns
              : category === 1
                ? voipColumns
                : tableColumn
          }
          rows={mappedRows}
          // showSlNo={false}
          // showCheckbox={false}
          serverPagination={false}
          totalCount={integrationData.length}
          page={page}
          limit={limit}
          onPaginationChange={setPage}
          onLimitChange={handleLimitChange}
          toolbarRight={{
            search: true,
            fullScreen: true,
            add: [
              {
                component: (
                  <Button title={"Update"} onClick={handleUpdate} size="sm" />
                ),
              },
            ],
          }}
        />
        <Backdrop isOpen={loading}>
          <LogoLoader />
        </Backdrop>
      </Modal>
    </div>
  );
};

export default AddBulkList;
